exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._38q9jEXGMxaovID1pBh5qT{fill:var(--neutralPrimary);width:30px!important;height:22px!important}html[dir=ltr] ._38q9jEXGMxaovID1pBh5qT{margin-right:-9px}html[dir=rtl] ._38q9jEXGMxaovID1pBh5qT{margin-left:-9px}", ""]);
// Exports
exports.locals = {
	"proofingIcon": "_38q9jEXGMxaovID1pBh5qT"
};